import * as yup from 'yup';
import { t } from 'i18next';
import dayjs from 'dayjs';

const startOfToday = dayjs().startOf('day').toDate();

// Validation schema for the leave request form
export const leaveRequestSchema = yup.object({
  startDate: yup
    .date()
    .required(t('validationFieldRequired', { name: t('startDate') }))
    .nullable()
    .min(startOfToday, t('EmployeeLeaveRequests.minStartDate'))
    .typeError(t('invalidDate', { field: t('startDate') })),
  endDate: yup
    .date()
    .required(t('validationFieldRequired', { name: t('endDate') }))
    .nullable()
    .min(
      yup.ref('startDate'),
      t('EmployeeLeaveRequests.minEndDate', { start: t('startDate') })
    )
    .typeError(t('invalidDate', { field: t('endDate') })),
  startTime: yup
    .date()
    .nullable()
    .typeError(t('invalidDate', { field: t('startTime') })),
  endTime: yup
    .date()
    .nullable()
    .min(
      yup.ref('startTime'),
      t('EmployeeLeaveRequests.minEndTime', { start: t('startTime') })
    )
    .typeError(t('invalidDate', { field: t('endTime') })),
  leaveType: yup
    .string()
    .required(t('validationFieldRequired', { name: t('leaveType') })),
  contractKind: yup
    .string()
    .required(t('validationFieldRequired', { name: t('contract') })),
  leaveRequestNote: yup
    .string()
    .max(1000, t('EmployeeLeaveRequests.noteMaxLength'))
});
